import {Injectable} from "@angular/core";
import {Http, Response} from "@angular/http";
import {User} from "../definitions";
import {Observable} from "rxjs/Observable";

import "rxjs/add/observable/of";
import "rxjs/add/operator/share";
import "rxjs/add/operator/map";

@Injectable()
export class AuthService {
  isLoggedIn:boolean = false;
  redirectUrl: string;


  private user:User;
  private observable:Observable<User>;


  constructor(private http: Http) {}


  authenticated():Observable<User> {
    if (this.user) {
      return Observable.of(this.user);
    }

    if (this.observable) {
      return this.observable;
    }

    this.observable = this.http.get("/api/whoami")
      .map((res:Response) => {
        this.observable = null;
        this.user = res.json()["user"] as User;

        return this.user;
      })
      .share();
    return this.observable;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/auth.service.ts